import {defineMessages} from 'react-intl';

export const tabsMessages = defineMessages({
  contents: { id: 'tabs.contents' },
  hide: { id: 'tabs.hide' },
  showAll: { id: 'tabs.show_all' },
});
